export const Spinner = ({ className = 'h-8 w-8' }: { className?: string }) => (
  <span
    className={`inline-block animate-spin rounded-full border-2 border-brand-500 border-t-transparent ${className}`}
    role="status"
    aria-label="Chargement"
  />
);
